var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CubedDeviceBoxAdapter_instances, _CubedDeviceBoxAdapter_context, _CubedDeviceBoxAdapter_box, _CubedDeviceBoxAdapter_parametric, _CubedDeviceBoxAdapter_wrapParameters;
import { clamp, Option, StringMapping, ValueMapping } from "@opendaw/lib-std";
import { Devices } from "../../DeviceAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
import { TrackType } from "../../timeline/TrackType";
import { CubedStep } from "./Cubed/CubedStep";
import { CubedRandomize } from "./Cubed/CubedRandomize";
const DefaultStep = CubedStep.pack({ note: CubedStep.DefaultNote, active: false, slide: false, accent: false });
export class CubedDeviceBoxAdapter {
    constructor(context, box) {
        _CubedDeviceBoxAdapter_instances.add(this);
        this.type = "instrument";
        this.accepts = "midi";
        this.manualUrl = "manuals/devices/instruments/cubed";
        _CubedDeviceBoxAdapter_context.set(this, void 0);
        _CubedDeviceBoxAdapter_box.set(this, void 0);
        _CubedDeviceBoxAdapter_parametric.set(this, void 0);
        __classPrivateFieldSet(this, _CubedDeviceBoxAdapter_context, context, "f");
        __classPrivateFieldSet(this, _CubedDeviceBoxAdapter_box, box, "f");
        __classPrivateFieldSet(this, _CubedDeviceBoxAdapter_parametric, new ParameterAdapterSet(__classPrivateFieldGet(this, _CubedDeviceBoxAdapter_context, "f")), "f");
        this.namedParameter = __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_instances, "m", _CubedDeviceBoxAdapter_wrapParameters).call(this, box);
    }
    get box() { return __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_box, "f"); }
    get uuid() { return __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_box, "f").address.uuid; }
    get address() { return __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_box, "f").address; }
    get labelField() { return __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_box, "f").label; }
    get iconField() { return __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_box, "f").icon; }
    get defaultTrackType() { return TrackType.Notes; }
    get enabledField() { return __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_box, "f").enabled; }
    get minimizedField() { return __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_box, "f").minimized; }
    get acceptsMidiEvents() { return true; }
    currentPattern() { return __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_box, "f").patterns.getField(__classPrivateFieldGet(this, _CubedDeviceBoxAdapter_box, "f").patternIndex.getValue()); }
    readCurrentPattern() {
        const pattern = this.currentPattern();
        const length = pattern.length.getValue();
        return {
            length,
            steps: pattern.steps.fields().slice(0, length).map(field => CubedStep.unpack(field.getValue()))
        };
    }
    writeCurrentPattern({ length, steps }) {
        const pattern = this.currentPattern();
        const fields = pattern.steps.fields();
        const used = Math.min(steps.length, fields.length);
        fields.forEach((field, index) => field.setValue(index < used ? CubedStep.pack(steps[index]) : DefaultStep));
        pattern.length.setValue(clamp(length, 1, fields.length));
    }
    clearCurrentPattern() {
        this.currentPattern().steps.fields().forEach(field => field.setValue(DefaultStep));
    }
    randomizeCurrentPattern(options = CubedRandomize.Default) {
        const pattern = this.currentPattern();
        const length = pattern.length.getValue();
        const steps = CubedRandomize.steps(options, length);
        pattern.steps.fields().forEach((field, index) => field.setValue(index < length ? steps[index] : DefaultStep));
    }
    rotateCurrentPattern(offset) {
        const pattern = this.currentPattern();
        const length = pattern.length.getValue();
        const fields = pattern.steps.fields().slice(0, length);
        const values = fields.map(field => field.getValue());
        fields.forEach((field, index) => field.setValue(values[(index + offset + length) % length]));
    }
    deviceHost() {
        return __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_context, "f").boxAdapters
            .adapterFor(__classPrivateFieldGet(this, _CubedDeviceBoxAdapter_box, "f").host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    *labeledAudioOutputs() {
        yield { address: this.address, label: this.labelField.getValue(), children: () => Option.None };
    }
    terminate() {
        __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_parametric, "f").terminate();
    }
}
_CubedDeviceBoxAdapter_context = new WeakMap(), _CubedDeviceBoxAdapter_box = new WeakMap(), _CubedDeviceBoxAdapter_parametric = new WeakMap(), _CubedDeviceBoxAdapter_instances = new WeakSet(), _CubedDeviceBoxAdapter_wrapParameters = function _CubedDeviceBoxAdapter_wrapParameters(box) {
    const unipolar = (field, name, anchor) => __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_parametric, "f").createParameter(field, ValueMapping.unipolar(), StringMapping.percent({ fractionDigits: 0 }), name, anchor);
    return {
        tuning: __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_parametric, "f").createParameter(box.tuning, ValueMapping.linear(-1200, 1200), StringMapping.numeric({ unit: "ct", fractionDigits: 0 }), "Tuning", 0.5),
        cutoff: unipolar(box.cutoff, "Cutoff"),
        resonance: unipolar(box.resonance, "Resonance"),
        envMod: unipolar(box.envMod, "Env Mod"),
        decay: unipolar(box.decay, "Decay"),
        accent: unipolar(box.accent, "Accent"),
        volume: __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_parametric, "f").createParameter(box.volume, ValueMapping.DefaultDecibel, StringMapping.numeric({ unit: "dB", fractionDigits: 1 }), "Volume"),
        waveform: __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_parametric, "f").createParameter(box.waveform, ValueMapping.linearInteger(0, 1), StringMapping.indices("", ["Sawtooth", "Square"]), "Waveform", 0.5),
        patternIndex: __classPrivateFieldGet(this, _CubedDeviceBoxAdapter_parametric, "f").createParameter(box.patternIndex, ValueMapping.linearInteger(0, box.patterns.fields().length - 1), StringMapping.oneBasedIndex(), "Pattern")
    };
};
